import React from "react";
import Layout from "../components/Layout/layout";
import { graphql } from "gatsby";

import Seo from "../components/seo";

import { MainScreenFirst, CrumbsNav } from "../components/Pages/About";

import { contactsData } from "../db/contactsData";
import { foodPhotographersStatic } from "../db/foodPhotographersStatic";
import BeautyPhotographers from "../components/Pages/BeautyPhotographers/BeautyPhotographers";

const BeautyPhotographersPage = ({ data }) => {
  const { strapiFoodPhotographersPage, strapiBeautyPhotographers } = data;
  return (
    <Layout>
      <Seo
        title={strapiFoodPhotographersPage.seo_title}
        description={strapiFoodPhotographersPage.seo_description}
      />

      <MainScreenFirst
        title={strapiFoodPhotographersPage.main.title}
        socials={contactsData.socials}
        showreel={strapiFoodPhotographersPage.main.showreel}
        video={strapiFoodPhotographersPage.main.video_cover}
        poster={strapiFoodPhotographersPage.main.poster}
      />

      <BeautyPhotographers
        foodPhotographers={strapiFoodPhotographersPage.photographers}
        beautyPhotographers={strapiBeautyPhotographers.Photographers}
        tickers={foodPhotographersStatic.tickers}
      />

      <CrumbsNav dataCrumbs={foodPhotographersStatic.crumbsNav} />
    </Layout>
  );
};

export default BeautyPhotographersPage;

export const query = graphql`
  query {
    strapiFoodPhotographersPage {
      seo_title
      seo_description
      main {
        title
        showreel
        video_cover {
          url
        }
        poster {
          url
        }
      }
      photographers {
        title
        link
        cover {
          cover_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 1400
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
      }
    }
    strapiBeautyPhotographers {
      seo_title
      seo_description
      main {
        title
        showreel
        video_cover {
          url
        }
        poster {
          url
        }
      }
      Photographers {
        title
        link
        cover {
          cover_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 1400
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
      }
    }
  }
`;
